import React from 'react'
import { Checkbox, FormControl, FormControlLabel, FormGroup, TextField } from '@mui/material'
import { formUpdate } from '../../lib/form'
import NaidesuHelp from '../rule-help/NaidesuHelp'

const RightRule = ({ rule, changeRule, entireRule }) => {
  const change = formUpdate(changeRule)

  return (
    <>
      <FormGroup className="rule-group">
        <TextField type="number" variant="standard"
                   label="解答権数" className="right-num"
                   inputProps={{ required: true, min: 1 }}
                   value={rule.num}
                   onChange={change.number(value => ({ num: { $set: value } }))} />
      </FormGroup>
      <FormGroup className="rule-group dense">
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox color="default" className="next-player"
                        checked={rule.nextPlayer}
                        onChange={change.checked(value => ({ nextPlayer: { $set: value } }))} />
            }
            label="正解時に次の人に解答権" />
        </FormControl>
      </FormGroup>
      <FormGroup className="rule-group">
        <FormControl>
          <FormControlLabel
            control={
              <Checkbox color="default" className="naidesu"
                        checked={rule.naidesu}
                        onChange={change.checked(value => ({ naidesu: { $set: value } }))} />
            }
            label={<>Naidesu<NaidesuHelp /></>} />
        </FormControl>
      </FormGroup>
    </>
  )
}

export default RightRule
